function MovideskGC() {
  this.apiUri = '';
  this.userData = {};
  this.chatKey = '';
  this.timeoutChatContinue = 3000;
  this.fnTimeoutChatContinue = null;
  this.isLoading = false;

  this.launcherWidgetElementId = 'js-mdLauncherWidget';
  this.preChatElementId = 'js-mdPreChat';
  this.preChatPreviewMessageElementId = 'js-mdPreChatPreviewMessage';
  this.preChatAlertElementId = 'js-mdPreChatAlert';
  this.preChatTopicListElementId = 'js-mdPreChatTopicList';
  this.chatContinueElementId = 'js-mdChatContinue';
}

var movideskGC = new MovideskGC();

MovideskGC.prototype.init = function (config) {
  movideskGC.apiUri = config.apiUri;
  movideskGC.userData = config.userData;
};

MovideskGC.prototype.startChat = function (trigger) {
  if (movideskGC.isLoading) return;

  movideskGC.isLoading = true;
  movideskGC.showLauncherWidgetLoading();

  axios.post(movideskGC.apiUri, { trigger: trigger, userData: movideskGC.userData })
    .then(function (response) {
      var data = response.data;
      movideskGC.chatKey = data.chatKey;

      if (data.alert) {
        movideskGC.renderPreChatAlert(data.alert);
      } else if (data.links) {
        movideskGC.renderPreChatTopicList(data.links);
      } else {
        movideskGC.hidePreChat(true);
      }
    })
    .catch(function (error) {
      movideskGC.showLauncherWidget();

      window.warning('Falha ao iniciar o chat com a nossa equipe de Community Experience. Tente novamente mais tarde.');
      window.console.error(error);
    })
    .finally(function () {
      movideskGC.isLoading = false;
    });
};

MovideskGC.prototype.initializeChat = function () {
  movideskGC.includeChat(movideskGC.chatKey, function () {
    window.movideskLogin({
      name: movideskGC.userData.name,
      email: movideskGC.userData.email,
      stayConnected: false,
      emptySubject: false,
      startChat: false
    });

    setTimeout(function () {
      movideskGC.hideLauncherWidget();
      movideskGC.showWidget();
    }, 400);
  });
};

MovideskGC.prototype.includeChat = function (chatKey, callback) {
  var head = document.head;
  var body = document.body;
  var oldStyle = document.getElementById('md-chat-widget-style');
  var clientOldScript = document.getElementById('movidesk-client-script');
  var oldScript = document.getElementById('movidesk-script');
  var oldWidget = document.getElementById('md-app-widget');

  if (oldStyle) {
    head.removeChild(oldStyle);
  }

  if (clientOldScript) {
    head.removeChild(clientOldScript);
  }

  if (oldScript) {
    head.removeChild(oldScript);
  }

  if (oldWidget) {
    body.removeChild(oldWidget);
  }

  var inlineVar = document.createTextNode('var mdChatClient= "' + chatKey + '";');
  var chatId = document.createElement('script');
  chatId.id = 'movidesk-client-script';
  chatId.type = 'text/javascript';

  chatId.appendChild(inlineVar);
  head.appendChild(chatId);

  var script = document.createElement('script');
  script.id = 'movidesk-script';
  script.src = 'https://chat.movidesk.com/Scripts/ChatWidget/Chat/chat-widget-new.min.js';
  script.type = 'text/javascript';
  script.onload = function () {
    if (callback) {
      callback();
    }
  };

  head.appendChild(script);
};

MovideskGC.prototype.showWidget = function () {
  document.getElementsByClassName('md-chat-widget-btn-close-icon')[0].addEventListener('click', movideskGC.hideWidget);
  document.getElementById('md-app-widget').style.visibility = 'visible';
  movideskGC.hideLauncherWidget();

  if (window.movideskChatWidgetChangeWindowState) {
    window.movideskChatWidgetChangeWindowState('maximized');
  }
};

MovideskGC.prototype.hideWidget = function () {
  document.getElementsByClassName('md-chat-widget-btn-close-icon')[0].removeEventListener('click', movideskGC.hideWidget);
  document.getElementById('md-app-widget').style.visibility = 'hidden';
  movideskGC.showLauncherWidget();
};

MovideskGC.prototype.setTimeoutChatContinue = function (timeout) {
  var newTimeout = Number.isInteger(timeout) && timeout > 0 ? timeout : 3000;
  movideskGC.timeoutChatContinue = newTimeout;
};

MovideskGC.prototype.showChatContinue = function () {
  movideskGC.fnTimeoutChatContinue = setTimeout(function () {
    var chatContinue = document.getElementById(movideskGC.chatContinueElementId);
    chatContinue.classList.remove('hidden');
  }, movideskGC.timeoutChatContinue);
};

MovideskGC.prototype.hideChatContinue = function () {
  clearTimeout(movideskGC.fnTimeoutChatContinue);
  document.getElementById(movideskGC.chatContinueElementId).classList.add('hidden');
};

MovideskGC.prototype.showPreChat = function (level, chatContinue) {
  movideskGC.hideLauncherWidget();

  if (chatContinue) {
    movideskGC.showChatContinue();
  }

  var preChat = document.getElementById(movideskGC.preChatElementId);
  preChat.dataset.level = level || 'info';
  preChat.classList.remove('hidden');
};

MovideskGC.prototype.hidePreChat = function (initializeChat) {
  var preChat = document.getElementById(movideskGC.preChatElementId);
  var preChatAlert = document.getElementById(movideskGC.preChatAlertElementId);
  var preChatTopicList = document.getElementById(movideskGC.preChatTopicListElementId);
  var preChatPreviewMessage = document.getElementById(movideskGC.preChatPreviewMessageElementId);

  preChat.classList.add('hidden');
  preChatAlert.innerHTML = '';
  preChatTopicList.innerHTML = '';
  preChatPreviewMessage.innerHTML = '';

  movideskGC.hideChatContinue();
  movideskGC.setTimeoutChatContinue();

  if (initializeChat) {
    movideskGC.initializeChat();
    if (window.movideskChatWidgetChangeWindowState) {
      window.movideskChatWidgetChangeWindowState('maximized');
    }
  } else {
    movideskGC.showLauncherWidget();
  }
};

MovideskGC.prototype.renderPreChatTopicList = function (topicList) {
  var topicListHtml = '<h3>Principais sugestões</h3>';

  topicListHtml += '<ul>';
  topicList.forEach(function (topic, index) {
    topicListHtml += '<li><a href="' + topic.url + '" target="_blank">';
    topicListHtml += '<span>' + (index + 1) + '.</span>' + topic.label;
    topicListHtml += '</a></li>';
  });
  topicListHtml += '</ul>';

  var preChatTopicList = document.getElementById(movideskGC.preChatTopicListElementId);
  preChatTopicList.innerHTML = topicListHtml;

  var level = 'info';
  movideskGC.renderPreChatPreviewMessage('links', level, true);
  movideskGC.showPreChat(level, true);
};

MovideskGC.prototype.renderPreChatAlert = function (alertData) {
  var defaultHtml = '';
  defaultHtml += alertData.image ? '<img src="' + alertData.image + '" />' : '';
  defaultHtml += alertData.name ? '<h3>' + alertData.name + '</h3>' : '';
  defaultHtml += alertData.description ? '<p>' + alertData.description + '</p>' : '';

  var preChatAlert = document.getElementById(movideskGC.preChatAlertElementId);
  preChatAlert.innerHTML = alertData.html ? alertData.html : defaultHtml;

  if (alertData.isChatEnabled) {
    movideskGC.setTimeoutChatContinue(alertData.continueDelay);
  }

  movideskGC.renderPreChatPreviewMessage('alert', alertData.type, alertData.isChatEnabled);
  movideskGC.showPreChat(alertData.type, alertData.isChatEnabled);
};

MovideskGC.prototype.renderPreChatPreviewMessage = function (template, level, chatContinue) {
  var preChatPreviewMessage = document.getElementById(movideskGC.preChatPreviewMessageElementId);
  var previewMessage = document.createElement('div');

  var className = '';
  var contentHtml = '';

  if (template === 'links') {
    className = 'info';
    contentHtml += '<i class="fas fa-question-circle"></i>';
    contentHtml += '<span>Tem alguma dúvida? Relaxa! A gente lista as perguntas mais comuns pra te ajudar!</span>';
  } else {
    className = level;
    if (chatContinue) {
      contentHtml += '<i class="fas fa-exclamation-triangle"></i>';
      contentHtml += '<span>Antes de continuar, um aviso importante!</span>';
    } else {
      contentHtml += '<i class="fas fa-radiation-alt"></i>';
      contentHtml += '<span>Eita! Estamos passando por algumas dificuldades no momento.</span>';
    }
  }

  previewMessage.className = className;
  previewMessage.innerHTML = contentHtml;

  preChatPreviewMessage.appendChild(previewMessage);
};

MovideskGC.prototype.showLauncherWidget = function () {
  document.getElementById(movideskGC.launcherWidgetElementId).classList.remove('hidden', 'MovideskLauncher--loading');
};

MovideskGC.prototype.hideLauncherWidget = function () {
  document.getElementById(movideskGC.launcherWidgetElementId).classList.add('hidden');
};

MovideskGC.prototype.showLauncherWidgetLoading = function () {
  document.getElementById(movideskGC.launcherWidgetElementId).classList.add('MovideskLauncher--loading');
};
